export class MiniGallery {
    init()
    {
        var miniGalleryLength = $('.gallery').length,
            noGridGalleryLength = $('.js-no-grid').length;

        if(miniGalleryLength)
        {
            for (var i = miniGalleryLength; i--; )
            {
                $('.gallery').eq(i).magnificPopup({
                    delegate: 'a',
                    type: 'image',
                    closeOnContentClick: true,
                    closeBtnInside: false,
                    fixedContentPos: true,
                    mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
                    image: {
                        verticalFit: true
                    },
                    tLoading: 'Ładuję...',
                    gallery: {
                        enabled: true,
                        tCounter: '<span class="mfp-counter">%curr% z %total%</span>'
                    },
                    zoom: {
                        enabled: false,
                        duration: 300 // don't foget to change the duration also in CSS
                    }
                });
            }
        }
    }
}